"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProp = function (element, key, value) {
    element[key] = value;
};
exports.getProp = function (element, key) {
    return element[key];
};
